import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {VisionProviderSummary} from '../../models/vision-provider-management';
import {AuthService} from '../../services/auth.service';
import {formatProviderLabel} from '../../services/vte/vision-customer-labels';
import {VisionProviderManagementViewService} from '../../services/vision-provider-management';
import {OperationsBackLinkComponent} from '../../shared/vte';

@Component({
    selector: 'app-provider-details-shell',
    standalone: true,
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, OperationsBackLinkComponent],
    templateUrl: './provider-details-shell.component.html',
    styleUrl: './provider-details-shell.component.css',
})
export class ProviderDetailsShellComponent implements OnInit {
    providerId = '';
    providerLabel = '';
    healthLabel = '';
    healthStatus: VisionProviderSummary['health_status'] = 'unavailable';
    loading = false;

    readonly tabItems = [
        {segment: 'overview', label: 'Overview'},
        {segment: 'authentication', label: 'Authentication'},
        {segment: 'event-subscriptions', label: 'Event Subscriptions'},
        {segment: 'diagnostics', label: 'Diagnostics'},
    ];

    constructor(
        private route: ActivatedRoute,
        private viewService: VisionProviderManagementViewService,
        private auth: AuthService,
    ) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.providerId = params.get('providerId') || '';
            this.loadProvider();
        });
    }

    get showImplementationDetails(): boolean {
        return this.auth.isSuperUser();
    }

    get providerSubtitle(): string {
        if (this.showImplementationDetails) {
            return this.providerId;
        }
        return this.providerLabel || formatProviderLabel(this.providerId, false);
    }

    loadProvider(): void {
        if (!this.providerId) {
            return;
        }
        this.loading = true;
        this.viewService.loadProviderSummary(this.providerId).subscribe({
            next: (summary) => {
                this.providerLabel = summary.provider_label;
                this.healthLabel = summary.health_label;
                this.healthStatus = summary.health_status;
                this.loading = false;
            },
            error: () => {
                this.providerLabel = formatProviderLabel(this.providerId, this.showImplementationDetails);
                this.healthLabel = 'Unavailable';
                this.healthStatus = 'unavailable';
                this.loading = false;
            },
        });
    }

    tabPath(segment: string): string {
        return `/vision-configuration/provider-management/providers/${this.providerId}/${segment}`;
    }

    statusClass(): string {
        return `provider-status-badge provider-status-badge--${this.healthStatus}`;
    }

    formatProviderLabel = formatProviderLabel;
}
